query GetApiKeysForDid(
  $id: ID!
  $first: Int
  $last: Int
  $after: String
  $before: String
  $query: String
  $queryList: [QueryItemInput!]
) {
  apiKeysForDid(
    didId: $id
    first: $first
    last: $last
    after: $after
    before: $before
    query: $query
    queryList: $queryList
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        id
        insertedAt
        updatedAt
        name
        token
      }
    }
  }
}
